import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale, FLOATING_ACTION_BAR_CLEARANCE } from '@/theme';
import { mq, fluidSpace } from '@/theme/scalingTokens';

export const useBookingsDashboardStyles = makeStyles({
  root: {
    width: '100%',
    overflowX: 'hidden',
  },

  contentArea: {
    width: '100%',
    paddingLeft: '5%',
    paddingRight: '5%',
    paddingTop: fluidSpace.xxl,
    paddingBottom: fluidSpace.xxl,
    boxSizing: 'border-box',
    [mq.tablet]: {
      paddingLeft: '24px',
      paddingRight: '24px',
      paddingTop: '24px',
    },
    [mq.mobile]: {
      paddingLeft: '16px',
      paddingRight: '16px',
      paddingTop: '16px',
    },
  },

  /**
   * Extra bottom clearance applied while the floating "book another" action
   * bar is visible (i.e., once the hero CTA scrolls out of view). Reserves
   * room so the pagination / last list row scrolls clear of the pinned bar
   * instead of being overlapped when scrolling stops.
   */
  contentAreaWithFloatingBar: {
    paddingBottom: FLOATING_ACTION_BAR_CLEARANCE,
  },

  heading: {
    fontWeight: 700,
    fontSize: fontScale.title,
    lineHeight: '1.3',
    color: tokens.colorNeutralForeground1,
    margin: '0',
    marginBottom: fluidSpace.xxs,
    // Offset programmatic scroll (pagination -> scrollIntoView) so the
    // heading clears the 3rem fixed header instead of being hidden by it.
    scrollMarginTop: '4rem',
  },

  subtitle: {
    fontWeight: 400,
    fontSize: fontScale.body,
    lineHeight: '1.43',
    color: tokens.colorNeutralForeground2,
    margin: '0',
    marginBottom: fluidSpace.xl,
  },

  sectionHeader: {
    fontSize: fontScale.body,
    fontWeight: 600,
    lineHeight: '1.4',
    color: tokens.colorNeutralForeground1,
    marginTop: fluidSpace.xl,
    marginBottom: 'clamp(12px, 0.9vw, 20px)',
    display: 'block',
  },

  tabContent: {
    marginTop: 'clamp(24px, 1.8vw, 36px)',
  },
});
